import { Component } from '@angular/core';

@Component({
  selector: 'greco-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent {}
